import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from "react-router-dom";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'

import {
    BasketProvider,
    MallProvider,
    NavProvider,
    PromptProvider, RespProvider,
    RootProvider,
    SpeechProvider,
    StoreProvider,
    UserProvider
} from "./providers";



const queryClient = new QueryClient();

const Providers = ({children}) =>{
    return(
        <PromptProvider>
            <RespProvider>
            <BasketProvider>
            <StoreProvider>
            <SpeechProvider>
                <NavProvider>
                    <MallProvider>
                        <UserProvider>
                            <RootProvider>
                                {children}
                            </RootProvider>
                        </UserProvider>
                    </MallProvider>
                </NavProvider>
            </SpeechProvider>
            </StoreProvider>
            </BasketProvider>
            </RespProvider>
        </PromptProvider>
    )
}


ReactDOM.render(
    <Router>
        <QueryClientProvider client={queryClient}>
        <Providers>
            <App />
        </Providers>
        </QueryClientProvider>
    </Router>,
    document.getElementById('root')
);

    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}

serviceWorker.register();
